/**
 * Postgres rejects 0x00 in text parameters ("invalid byte sequence for
 * encoding UTF8"), so any free-text value bound for Prisma must go through
 * this first. Scanner traffic sends `%00` in query params (NWA-3716).
 */
export function stripNullBytes(value: string): string {
  return value.replaceAll('\0', '');
}
